import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <p>There are a number of techniques that you can use to create
                                                impact through your body language: Here are two of the most
                                                powerful.</p>
                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">Mirroring</div>
                                                <p>When you see two people engaged in an intimate conversation
                                                    you probably notice how they tend to hold themselves in the
                                                    same kind of body posture, holding their heads in similar
                                                    ways or making gestures of a similar size. In this context,
                                                    the two individuals will probably be instinctively mirroring
                                                    each other. In the same way, you can use ‘mirroring’ to
                                                    encourage an easier flow of communication without the other
                                                    person thinking you’re making an extra effort. Matching body
                                                    language to gain rapport involves adopting a similar
                                                    posture, giving the same amount of eye contact and matching
                                                    the speed and general frequency of hand gestures. Don’t
                                                    overdo it, though, or you’ll have the opposite effect to
                                                    what you want!</p>
                                            </div>
                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">Mismatching</div>
                                                <p>Mismatching is the opposite of mirroring and can also be
                                                    useful. Although disengaging, it need not invalidate the
                                                    other person. It can be used to extricate yourself from a
                                                    conversation or help bring a discussion to a close. In this
                                                    situation you may see people increasing distance between
                                                    themselves and others, or reducing eye contact.</p>
                                            </div>
                                            <div className="border_subtitle">3. Verbal communication</div>
                                            <p>Although the language that we use only accounts for a proportion
                                                of our communication, when you match the verbal style of the
                                                person you’re talking to you can strongly influence rapport.
                                                Matching the volume, words, phrases and images used and, to some
                                                extent, the beliefs and opinion of the person you’re speaking to
                                                is known as ‘pacing’.</p>
                                            <p><span className="subtitle-table">Pacing volume</span></p>
                                            <p>You can pace the volume of the conversation by speaking more
                                                softly to someone with a quiet voice and more loudly to a person
                                                with a louder voice. When you match someone in the volume of
                                                your voice you indicate you’re ‘on the same wavelength’ and are
                                                far less likely to be viewed as threatening. People have a
                                                tendency to prefer relating to people they consider similar to
                                                themselves and, as a result, feel more comfortable in
                                                conversation with them.</p>
                                            <p><span
                                                className="subtitle-table">Pacing words, phrases and images</span>
                                            </p>
                                            <p>The words, phrases and images that people use give us clues about
                                                how they perceive the world. Some people tend to think in images
                                                (visual), others prefer to discuss a concept to hear how it
                                                sounds (auditory) while others need to experience how something
                                                feels (kinesthetic).<a className="superscripttext"
                                                                       href="further_info.php?course=300"><sup>4</sup></a> When
                                                you pace this aspect of their speech you gain trust by
                                                demonstrating that you understand them. You can do this by using
                                                words, phrases and images the other person uses, in a way that
                                                you’re comfortable with.</p>
                                            <p><span
                                                className="subtitle-table">Pacing beliefs and opinions</span>
                                            </p>
                                            <p>Validating some of the things the person you’re talking to
                                                believes in is affirming and strengthens connection. For
                                                example, if you’re talking about packaging for a new product you
                                                could ‘validate’ the other person by saying that you thought
                                                they’d be interested as you know they are artistic.</p>


                                            <div className="left-btn"><a
                                                onClick={this.props.handleChangePage('Page3')}
                                                className="button-next-previous-done">&lt;&lt; Previous </a></div>
                                            <div className="right-btn"><a onClick={this.props.handleChangePage('Page5')}
                                                                          className="button-next-previous-done">Next &gt;&gt;</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    }
}